import request from '@/utils/seftRequest';
import TTrequest from '@/utils/ttRequest';
import portalRequest from '@/utils/request';

// 查询TT服务类型
export function qryTTCategoryList(data) {
  return request('/ding/troubleTicket/qryServiceTypeBsnl', {
    method: 'POST',
    body: data,
  });
}
// 查询TT紧急程度
export function qryEmergencyList() {
  return request('/ding/troubleTicket/qryEmergencyBsnl');
}

// 提交TT单 drm/ding/troubleTicket/saveAndSubmitOrderBsnl
export function saveTTOrder(data) {
  return request('/ding/troubleTicket/saveAndSubmitOrderBsnl', {
    method: 'POST',
    body: data,
  });
}

// 查询TT单列表 drm/ding/troubleTicket/qryTTOrderListBsnl
export function qryTTOrderList(data) {
  return TTrequest('/tt/v2/order/order-list', {
    method: 'POST',
    body: data,
  });
}

// 查询TT单状态 drm/ding/troubleTicket/qryOrderStateBsnl
export function qryOrderState() {
  return request('/ding/troubleTicket/qryOrderStateBsnl');
}

// 关闭TT单 drm/ding/troubleTicket/closeOrderBsnl
export function closeOrder(data) {
  return request('/ding/troubleTicket/closeOrderBsnl', {
    method: 'POST',
    body: data,
  });
}

// 重启TT单 /tt/v1/order/modify
export function reopenOrder(data) {
  return TTrequest('/tt/v1/order/modify', {
    method: 'POST',
    body: data,
  });
}

// 打回TT单 /tt/v2/task/return
export function processOrder(data) {
  return TTrequest('/tt/v2/task/return', {
    method: 'POST',
    body: data,
  });
}

// fm列表查询 /drm/selfserv/qryChnlMgrList
export function qryChnlMgrList(params) {
  return portalRequest(`/drm/selfserv/qryChnlMgrList/${params.orgId}?orgId=${params.orgId}`);
}
